import type { ReactionEmojiKey } from '@gik/ui/OpenMoji';
import type { UR } from 'getstream';
import type { Reaction } from '../types/Stream';

export function getReactionIconName(reaction: Reaction<UR>): ReactionEmojiKey {
  return reaction?.kind as ReactionEmojiKey;
}
